import { List } from "@mui/material"
import { RegisterSystemTask } from "event-definitions"
import { Repeat } from "lib/@components/repeat"
import { useAsync } from "lib/@hooks/useAsync"
import { Task } from "routes/sfg20-admin/plugins/system-tab/tasks-tab/task"

export async function getTasks() {
    return RegisterSystemTask.callAsync({ tasks: [] })
}

export function Tasks() {
    const tasks = useAsync(getTasks, [])
    return (
        <List>
            <Repeat list={tasks.sortBy("name")} item={<Task />} pass="task" bind />
        </List>
    )
}
